import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=22575c85&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=22575c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22575c85",
  null
  
)

export default component.exports